<div class="card">
  <p style="color: #6B77A1;text-align: left;padding-left:0.5em;">{{  pointData ? pointData.name : '-' }}</p>
  <p *ngIf="pointData" style="font-size: 22px;color: #20417b;font-weight: bold;text-align: center"> {{ pointData.current | number : '1.2-2'}} {{ pointData.unitOfMeasure }} </p>
  <p *ngIf="pointData" style="color: #20417b;text-align: center">
    Prec: {{ pointData.previous | number : '1.2-2' }}
    <span style="color: green;" *ngIf="pointData.diffPercentage >= 0">  ( + {{ pointData.diffPercentage | number : '1.2-2'}} % ) </span>
    <span style="color: red;"  *ngIf="pointData.diffPercentage < 0">( {{ pointData.diffPercentage | number : '1.2-2'}} % )</span>
  </p>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/points/fondo-di-accantonamento-indicator/fondo-di-accantonamento-indicator.component.html